
import { defineComponent, computed, onMounted, onBeforeMount, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import TheSearchResultMain from '@/components/organisms/TheSearchResultMain.vue'
import TheMyCollectionMain from '@/components/organisms/TheMyCollectionMain.vue'
import TheSearchImageResultMain from '@/components/organisms/TheSearchImageResultMain.vue'
import TheMyCollectionLeftColumn from '@/components/organisms/TheMyCollectionLeftColumn.vue'
import LoadingView from '@/components/molecules/LoadingView.vue'

export default defineComponent({
  name: 'MyCollection',
  components: {
    TheSearchResultMain,
    TheMyCollectionMain,
    TheSearchImageResultMain,
    TheMyCollectionLeftColumn,
    LoadingView,
  },
  props: {
    component: {
      type: String,
      required: true,
    },
    collection: {
      type: Object,
      required: false
    }
  },
  setup () {
    const router = useRouter()
    const store = useStore()
    const result = computed(() => store.getters.ItemList)
    const isProcessing = computed(() => store.getters.myCollectionIsProcessing)
    const isLoggedIn = computed(() => store.getters.isLoggedIn)

    onBeforeMount(() => {
      if (!isLoggedIn.value) {
        store.commit('NotLoggedIn', true)
        router.push({ path: '/' })
      }
    })

    onMounted(() => {
      if (isLoggedIn.value) {
        store.dispatch('myCollectionInit')
      }
    })

    return {
      result,
      isProcessing,
      showModal: ref(false),
    }
  },
})
